import * as currencyJs from 'currency.js';

import { environment } from '../../../environments/environment';

// @ts-ignore
const currencyUtil = (value: currency.Any, opts?: currency.Options): currency => {
  return currencyJs(value, opts || (environment.currencyOptions as currencyJs.Options));
};

export { currencyUtil };
